import { render, staticRenderFns } from "./DocumentCustomer.vue?vue&type=template&id=321beb2b&scoped=true&"
import script from "./DocumentCustomer.vue?vue&type=script&lang=js&"
export * from "./DocumentCustomer.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCustomer.vue?vue&type=style&index=0&id=321beb2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321beb2b",
  null
  
)

export default component.exports